import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import LeftNav from './LeftNav'
import TopBar from './TopBar'

export default function AppShell() {
  const [navCollapsed, setNavCollapsed] = useState(() => {
    const stored = localStorage.getItem('navCollapsed')
    return stored === 'true'
  })

  const handleToggle = () => {
    setNavCollapsed(prev => {
      localStorage.setItem('navCollapsed', String(!prev))
      return !prev
    })
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <LeftNav collapsed={navCollapsed} onToggle={handleToggle} />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <TopBar />
        <Box component="main" sx={{ flex: 1, overflow: 'auto', p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}
